import React, { useState } from "react";
import Quiz from 'react-quiz-component';
import quiz from '../Frenchquiz.json';
import PageTitle from "../PageTitle";
import { FlashcardArray } from "react-quizlet-flashcard";
import frenchData from '../French.json'
import { Box, Button, Container } from "@mui/material";
import Rouge from '../../sounds/Frenchsounds/Rouge.mp3';
import Gris from '../../sounds/Frenchsounds/Gris.mp3';
import Jaune from '../../sounds/Frenchsounds/Jaune.mp3';
import Noir from '../../sounds/Frenchsounds/Noir.mp3';
import Orange from '../../sounds/Frenchsounds/Orange.mp3';
import Rose from '../../sounds/Frenchsounds/Rose.mp3';
import Vert from '../../sounds/Frenchsounds/Vert.mp3';
import Bleu from '../../sounds/Frenchsounds/Bleu.mp3';
import Blanc from '../../sounds/Frenchsounds/Blanc.mp3';
import Brun from '../../sounds/Frenchsounds/Brun.mp3';

function French() {
  //setting state values
  const [showFlash, setShowFlash] = useState(true);
  const [currentCard, setCurrentCard] = useState(1);
  const [data] = useState([...frenchData]);
  const [categoryFilter, setCategoryFilter] = useState('All');

  //function to filter json data by category
  const filteredData = data.filter(item => {
    if (categoryFilter === 'All') {
      return true;
    } else {
      return item.category === categoryFilter;
    }
  });

  //function to determine when the flashcards show up
  const handleFlashClick = () => {
    setShowFlash(true);
  };

  //function to determine when the quiz shows up
  const handleQuizClick = () => {
    setShowFlash(false);
  };

  //function to determine which category was selected
  const handleCategoryClick = (category) => {
    setCategoryFilter(category);
  };

  //function to play audio clips depending on current card index
  function play() {
    if (currentCard === 1) {
    new Audio(Rouge).play()}
    else if (currentCard === 2) {
      new Audio(Orange).play()}
    else if (currentCard === 3) {
      new Audio(Jaune).play()
    }else if (currentCard === 4) {
      new Audio(Vert).play()
    }else if (currentCard === 5) {
      new Audio(Bleu).play()
    }else if (currentCard === 6) {
      new Audio(Blanc).play()
    }else if (currentCard === 7) {
      new Audio(Noir).play()
    }else if (currentCard === 8) {
      new Audio(Brun).play()
    }else if (currentCard === 9) {
      new Audio(Rose).play()
    }else 
      new Audio(Gris).play()
    }

    //function to update card index
    const handleCardChange = (index) => {
      setCurrentCard(index);
    };

  return (
    <Container sx={{padding: "20px", display: "flex", flexDirection: 'column', justifyContent: "center", alignItems: "center"}}>
      <PageTitle title="French"/>
      <Container sx={{display: "flex", flexDirection: 'column', justifyContent: "center", alignItems: "center"}}>
        <Box sx={{display: "flex", justifyContent: "space-around", alignItems: "center"}}>
          <Button color="secondary"   sx={{margin: "10px"}}onClick={handleQuizClick} variant="contained" size="large">Quiz</Button>
          <Button color="secondary" onClick={handleFlashClick} variant="contained" size="large">Flashcards</Button>
        </Box>
        
        {showFlash ? (
         <Box>
         <Box sx={{display: "flex", justifyContent: "center", alignItems: "center"}}>
           <Button onClick={() => handleCategoryClick('All')}>All</Button>
           <Button onClick={() => handleCategoryClick('colours')}>Colours</Button>
           <Button onClick={() => handleCategoryClick('nature')}>Nature</Button>
           <Button onClick={() => handleCategoryClick('household_items')}>Household Items</Button>
         </Box>
         <Box>
           <FlashcardArray 
             cards={filteredData} 
             onCardChange={handleCardChange}/>
         </Box>
         <Box sx={{display: "flex", justifyContent: "center", alignItems: "center"}}>
         <Button variant="contained" color="secondary" onClick={play}>Play Sound</Button>
         </Box>
       </Box>
        ) : (
          <Box>
            <Quiz quiz={quiz}/>
          </Box>
        )}
      </Container>
      </Container>
  );
}

export default French;